'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import I18n from 'I18n';
import formatName from 'I18n/utils/formatName';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UISelectableButton from 'UIComponents/button/UISelectableBox';
import Small from 'UIComponents/elements/Small';
import { UNAVAILABLE_REASONS } from 'MeetingsLib/constants/enums';
import { getPrimaryColorOrDefault } from 'MeetingsBase/utils/color';
import { getColorStyleWithOpacity } from 'MeetingsLib/utils/color';
import PreviewContext from 'MeetingsLib/utils/PreviewContext';
import Branding from 'MeetingsBase/models/Branding';
export default createReactClass({
  displayName: "TimePickerButton",
  propTypes: {
    branding: PropTypes.instanceOf(Branding).isRequired,
    disabled: PropTypes.bool,
    handleSetEventDateTime: PropTypes.func.isRequired,
    conflictingEvent: PropTypes.shape({
      email: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      relatedEventStartTimeMillis: PropTypes.number
    }),
    selectedTime: PropTypes.number,
    time: PropTypes.number.isRequired,
    unavailableReason: PropTypes.string,
    userTimezone: PropTypes.string.isRequired,
    selectedDate: PropTypes.string.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      hover: false
    };
  },
  onMouseEnter: function onMouseEnter() {
    this.setState({
      hover: true
    });
  },
  onMouseLeave: function onMouseLeave() {
    this.setState({
      hover: false
    });
  },
  getBrandingActiveStyle: function getBrandingActiveStyle() {
    var _this$props = this.props,
        primaryColor = _this$props.branding.primaryColor,
        time = _this$props.time,
        selectedTime = _this$props.selectedTime;
    var hover = this.state.hover;

    if (!hover && time !== selectedTime) {
      return null;
    }

    return {
      borderColor: primaryColor,
      backgroundColor: getColorStyleWithOpacity(primaryColor)
    };
  },
  getBrandingTextStyle: function getBrandingTextStyle() {
    var primaryColor = this.props.branding.primaryColor;

    if (!primaryColor) {
      return null;
    }

    return {
      color: getPrimaryColorOrDefault(primaryColor)
    };
  },
  getOwnerName: function getOwnerName() {
    var _this$props$conflicti = this.props.conflictingEvent,
        firstName = _this$props$conflicti.firstName,
        lastName = _this$props$conflicti.lastName,
        email = _this$props$conflicti.email;
    var formattedName = formatName({
      firstName: firstName,
      lastName: lastName
    });
    return formattedName || email;
  },
  getUnavailableMessageProps: function getUnavailableMessageProps() {
    var _this$props2 = this.props,
        unavailableReason = _this$props2.unavailableReason,
        relatedEventStartTimeMillis = _this$props2.conflictingEvent.relatedEventStartTimeMillis;
    var ownerName = this.getOwnerName();

    switch (unavailableReason) {
      case UNAVAILABLE_REASONS.PAST:
        return {
          message: 'troubleshoot.past'
        };

      case UNAVAILABLE_REASONS.ALL_DAY_EVENT:
        return {
          message: 'troubleshoot.allDayBusy',
          options: {
            ownerName: ownerName
          }
        };

      case UNAVAILABLE_REASONS.EVENT:
        return {
          message: 'troubleshoot.busy',
          options: {
            ownerName: ownerName
          }
        };

      case UNAVAILABLE_REASONS.BUFFER:
        return {
          message: 'troubleshoot.buffer',
          options: {
            relatedEventStartTime: this.getLowercaseTime(relatedEventStartTimeMillis)
          }
        };

      case UNAVAILABLE_REASONS.MINIMUM_NOTICE:
        return {
          message: 'troubleshoot.minimumNotice'
        };

      default:
        return {
          message: 'troubleshoot.default'
        };
    }
  },
  getLowercaseTime: function getLowercaseTime(timestamp) {
    var userTimezone = this.props.userTimezone;
    var timeOfDay = I18n.moment(timestamp).tz(userTimezone).format('LT');
    return timeOfDay.toLowerCase();
  },
  renderUnavailableReason: function renderUnavailableReason() {
    var disabled = this.props.disabled;

    if (!disabled) {
      return null;
    }

    var text = /*#__PURE__*/_jsx(FormattedReactMessage, Object.assign({}, this.getUnavailableMessageProps()));

    return /*#__PURE__*/_jsx(UITruncateString, {
      tooltip: /*#__PURE__*/_jsx(Small, {
        children: text
      }),
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: text
      })
    });
  },
  renderMinutes: function renderMinutes() {
    var _this$props3 = this.props,
        time = _this$props3.time,
        selectedDate = _this$props3.selectedDate;
    var lowerCaseTimeOfDay = this.getLowercaseTime(time);
    return /*#__PURE__*/_jsx("span", {
      "aria-label": I18n.text('prebook.timePicker.timePickerButtonLabel', {
        timeOption: lowerCaseTimeOfDay,
        selectedDate: I18n.moment(selectedDate).format('MMMM Do')
      }),
      style: this.getBrandingTextStyle(),
      children: lowerCaseTimeOfDay
    });
  },
  render: function render() {
    var _this = this;

    var _this$props4 = this.props,
        disabled = _this$props4.disabled,
        handleSetEventDateTime = _this$props4.handleSetEventDateTime,
        selectedTime = _this$props4.selectedTime,
        time = _this$props4.time;
    return /*#__PURE__*/_jsx("div", {
      className: "p-y-1 p-right-1",
      children: /*#__PURE__*/_jsx(PreviewContext.Consumer, {
        children: function children(isPreview) {
          return /*#__PURE__*/_jsxs(UISelectableButton, {
            disabled: disabled,
            block: true,
            padded: false,
            className: "time-picker-btn",
            selected: selectedTime === time,
            style: _this.getBrandingActiveStyle(),
            onMouseEnter: _this.onMouseEnter,
            onMouseLeave: _this.onMouseLeave,
            onClick: isPreview ? null : handleSetEventDateTime,
            children: [_this.renderMinutes(), /*#__PURE__*/_jsx("br", {}), _this.renderUnavailableReason()]
          });
        }
      })
    });
  }
});